
if (!customElements.get('gift-recipt-form')) {
  customElements.define(
    'gift-recipt-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector(`#Recipient_checkbox--${this.dataset.sectionId}`);
        this.checkbox.disabled = false;
        this.hiddenControls = this.querySelector(`#Recipient_control--${this.dataset.sectionId}`);
        this.wrapper = this.querySelector('.recipients_input_wrapper');
        this.inner = this.wrapper.querySelector('.recipients_input_inner');
        this.hiddenControls.disabled = true;

        this.emailInput = this.querySelector(`#Recipient_email--${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient_name--${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient_message--${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient_send_on--${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient_timezone_offset--${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.currentProductVariantId = this.dataset.variantId;
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        const height = this.inner.clientHeight;
        this.wrapper.style.setProperty('--height', `${height}px`);
      }

      onChange() {
        if(this.checkbox.checked) {
          this.wrapper.setAttribute('open', '');
        } else {
          this.wrapper.removeAttribute('open');
        }
      }
    }
  )
}
class ScrollToTop extends HTMLElement {
  connectedCallback() {
    this.progressFill = this.querySelector('.scroll-progress-fill');
    this.circumference = 163.36; // 2 * π * 26 (matches SVG r="26")

    this.boundUpdate = this.update.bind(this);
    window.addEventListener('scroll', this.boundUpdate, { passive: true });
    this.update();

    this.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.boundUpdate);
  }

  update() {
    const scrollTop = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const progress = maxScroll > 0 ? Math.min(scrollTop / maxScroll, 1) : 0;

    if (this.progressFill) {
      this.progressFill.style.strokeDashoffset = this.circumference * (1 - progress);
    }

    if (scrollTop > 150) {
      this.classList.add('show');
    } else {
      this.classList.remove('show');
    }
  }
}

customElements.define('scroll-to-top', ScrollToTop);



class ScrollList extends HTMLElement {
  connectedCallback() {
    this.outer = this.querySelector(".scroll-list-outer");
    this.original = this.outer?.querySelector(".sticky_scroll_container");
    if (!this.original) return;

    this.userSpeed = Number(this.dataset.speed) || 100;
    this.direction = -1;
    this.pos = 0;
    this.paused = false;
    this.running = false;

    // Reduced motion
    this.reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (this.reduceMotion) return;

    // Clone once
    this.clone = this.original.cloneNode(true);
    this.clone.classList.add("scroll-clone");
    this.outer.appendChild(this.clone);

    this.width = this.original.getBoundingClientRect().width;
    this.cloneStart = this.width;
    this.speedFactor = this.userSpeed * 0.08;

    // Hover pause
    // this.addEventListener("mouseenter", () => (this.paused = true));
    // this.addEventListener("mouseleave", () => (this.paused = false));

    // Visibility observer (CRITICAL)
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.start();
        } else {
          this.stop();
        }
      },
      { threshold: 0 }
    );

    this.observer.observe(this);

    // Tab visibility
    document.addEventListener("visibilitychange", () => {
      document.hidden ? this.stop() : this.start();
    });
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.animate();
  }

  stop() {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }

  animate() {
    if (!this.running) return;

    if (!this.paused) {
      this.pos += this.direction * this.speedFactor;
      this.outer.style.transform = `translate3d(${this.pos}px,0,0)`;

      if (this.direction === -1 && Math.abs(this.pos) >= this.cloneStart) {
        this.direction = 1;
      }
      if (this.direction === 1 && this.pos >= 0) {
        this.direction = -1;
      }
    }

    this.raf = requestAnimationFrame(() => this.animate());
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
  }
}

customElements.define("scroll-list", ScrollList);

class ImageGallerySlider extends HTMLElement {

  connectedCallback() {
    this.initWhenReady();
  }

  disconnectedCallback() {
    if (this.leftSwiper && typeof this.leftSwiper.destroy === 'function') {
      this.leftSwiper.destroy(true, true);
      this.leftSwiper = null;
    }

    if (this.rightSwiper && typeof this.rightSwiper.destroy === 'function') {
      this.rightSwiper.destroy(true, true);
      this.rightSwiper = null;
    }
  }

  initWhenReady(attempt = 0) {
    if (this.leftSwiper || this.rightSwiper) return;

    const leftSlider = this.querySelector('.image-gallery-swiper--left');
    const rightSlider = this.querySelector('.image-gallery-swiper--right');
    if (!leftSlider && !rightSlider) return;

    if (typeof window.Swiper === 'undefined') {
      if (attempt < 80) {
        setTimeout(() => this.initWhenReady(attempt + 1), 100);
      }
      return;
    }

    const wrapper = this.querySelector('.image-gallery-slider-wrapper');

    const totalSlides = Number(wrapper.dataset.totalSlides);
    const desktopSlides = Math.ceil(totalSlides / 2);

    // console.log("Total:", totalSlides);
    // console.log("Per slider:", desktopSlides);

    const commonConfig = {
      loop: true,
      speed: 2000,
      allowTouchMove: true,
      centeredSlides: false,
      watchSlidesProgress: true,
      breakpoints: { 
        0: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        990: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1200: {
          slidesPerView:desktopSlides,
          spaceBetween: 20
        }
      } 
    };

    if (leftSlider) { 
      this.leftSwiper = new window.Swiper(leftSlider, {
        ...commonConfig
      });
    }

    if (rightSlider) {
      this.rightSwiper = new window.Swiper(rightSlider, {
        ...commonConfig,
        reverseDirection: true
      });
    }

    if (this.leftSwiper && this.rightSwiper) {
      this.leftSwiper.controller.control = this.rightSwiper;
      this.rightSwiper.controller.control = this.leftSwiper;
    }

    this.syncFocusableSlideLinks();
  }

  syncFocusableSlideLinks() {
    const setupAccessibility = (swiper) => {
      if (!swiper || !swiper.el) return;

      const updateSlides = () => {
        const slides = swiper.el.querySelectorAll('.swiper-slide');

        slides.forEach((slide) => {
          const link = slide.querySelector('.image-gallery-slide-link');

          if (!link) return;

          if (slide.classList.contains('swiper-slide-duplicate')) {
            link.setAttribute('tabindex', '-1');
            link.setAttribute('aria-hidden', 'true');
          } else {
            link.removeAttribute('tabindex');
            link.removeAttribute('aria-hidden');
          }
        });
      };

      updateSlides();

      swiper.on('slideChange', updateSlides);
      swiper.on('transitionEnd', updateSlides);
      swiper.on('loopFix', updateSlides);
      swiper.on('resize', updateSlides);
      swiper.on('observerUpdate', updateSlides);
    };

    setupAccessibility(this.leftSwiper);
    setupAccessibility(this.rightSwiper);
  }
}

if (!customElements.get('image-gallery-slider')) {
  customElements.define('image-gallery-slider', ImageGallerySlider);
}
// VIDEO SECTION
class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.playBtn = this.querySelector('.video_play_btn');
    this.imgWrapper = this.querySelector('.hosted-video-poster_img_wrapper');
    this.vdoWrapper = this.querySelector('.hosted-video-video_wrapper');
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
  }

 connectedCallback() {
  this.playBtn.addEventListener('click', this.handleClick.bind(this));

  /* Keep the media layer out of the tab order and accessibility tree until
     the video is played. `inert` reliably covers iframe embeds, whose
     internal controls a `tabindex="-1"` on the <iframe> cannot remove. */
  if (this.vdoWrapper) {
    this.vdoWrapper.setAttribute('inert', '');
  }

  if (this.video) {
    this.video.addEventListener('click', this.handleVdoClick.bind(this));
  }
}


 handleClick() {
  if (!this.imgWrapper || !this.vdoWrapper) return;

  this.imgWrapper.classList.add('hide');

  /* Remove the poster + play button from tab order / a11y tree.
     (`tabindex`/`aria-hidden` kept as a fallback for browsers without inert.) */
  this.imgWrapper.setAttribute('inert', '');
  this.playBtn.setAttribute('tabindex', '-1');
  this.playBtn.setAttribute('aria-hidden', 'true');

  /* Activate the media layer so its controls become focusable */
  this.vdoWrapper.removeAttribute('inert');

  if (this.video) {
    this.video.focus();
    this.video.play();
  } else if (this.iframe) {
    const src = this.iframe.getAttribute("src");

    if (src.includes("youtube")) {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    } else if (src.includes("vimeo")) {
      this.iframe.contentWindow.postMessage(
        '{"method":"play"}',
        "https://player.vimeo.com"
      );
    }

    this.iframe.focus();
  }
}


  handleVdoClick() {
    if(this.vdoWrapper.classList.contains('controls_enabled')) {} else {
      if(this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }
}

 customElements.define('hosted-video', VideoSection);


class PromotionalPopup extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }
 
  connectedCallback() {
    this.overlay = this.querySelector('.promotional_popup_outer');
    this.wrapper = this.querySelector('.promotional_popup_section-id');
    this.closeBtn = this.querySelector('.promotional_popup_close_button button');
    this.noth = this.querySelector('.no_th button');  
    if (!this.wrapper) return; 

    if (this.hasAttribute('open')) {
      requestAnimationFrame(() => this.show());
    } else if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.cascade);
    }

    this.closeBtn?.addEventListener('click', e => {
      e.preventDefault();
      this.hide();
      this.cleanUrl();
    });
    this.noth?.addEventListener('click', e => {
      e.preventDefault();
      this.hide();
    });
  }

  get cascade() {
    return Number(this.getAttribute('cascade') || 0) * 1000;
  }

  show() {  
    this.overlay.classList.add('show');
    this.wrapper.classList.add('visible');
    this.setAttribute('open', '');
    localStorage.setItem('theme:popup-appeared', 'true');
  }

  hide() { 
    this.overlay.classList.remove('show');
    this.wrapper.classList.remove('visible');
    this.removeAttribute('open');
  }

  cleanUrl() {
    const url = window.location.href
      .replace('?customer_posted=true', '')
      .replace(/(&|\?)$/, '');
    window.history.replaceState({}, document.title, url);
  }

  get shouldAppearAutomatically() {
    if (this.hasAttribute('open')) return false;

    if (localStorage.getItem('theme:popup-filled') === 'true') return false;

    if (
      this.hasAttribute('only-once') &&
      localStorage.getItem('theme:popup-appeared') === 'true'
    ) {
      return false;
    }

    return true;
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'open' && newVal !== null) {
      localStorage.setItem('theme:popup-appeared', 'true');
    }
  }
}

customElements.define('promotional-popup', PromotionalPopup);

class QuickViewWrap extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('#quick-view-drawer');
    if (!this.drawer) return;

    this.initFocusTrap();
    this.observeOpenState();
  }

  observeOpenState() {
    const observer = new MutationObserver(() => {
      if (this.drawer.classList.contains('active')) {
        this.focusFirstElement();
      }
    });

    observer.observe(this.drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  initFocusTrap() {
    this.drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const focusable = this.getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first || !this.drawer.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  getFocusableElements() {
    return Array.from(
      this.drawer.querySelectorAll(`
        a[href],
        button:not([disabled]),
        textarea:not([disabled]),
        input:not([disabled]),
        select:not([disabled]),
        [tabindex]:not([tabindex="-1"])
      `)
    ).filter(el => el.offsetParent !== null);
  }

  focusFirstElement() {
    requestAnimationFrame(() => {
      const focusable = this.getFocusableElements();
      if (focusable.length) {
        focusable[0].focus();
      }
    });
  }
}

customElements.define('quick-view-wrap', QuickViewWrap); 
 

class QuickAddButton extends HTMLElement {

  constructor() {
    super();

    this.productUrl =
      this.dataset.productUrl;

    this.mainDrawer =
      document.querySelector(
        '.quick-view-drawer_wrapper'
      );

    this.drawer =
      document.querySelector(
        '.quick-view-drawer_inner'
      );

    this.icon =
      this.querySelector(
        '.icon_wrapper'
      );

    this.loader =
      this.querySelector(
        '.form_loader'
      );

    this.isLoading = false;
  }

  connectedCallback() {

    if (this._initialized) return;

    this._initialized = true;

    this.attachEvents();

  }

  attachEvents() {

    this.addEventListener(
      'click',
      (event) => {

        event.preventDefault();

        if (
          !this.productUrl ||
          this.isLoading
        ) {
          return;
        }

        this._triggerButton = document.activeElement instanceof HTMLElement
          ? document.activeElement
          : this.querySelector('button');

        this.showLoader();

        this.handleFetch();

      }
    );

  }

  showLoader() {

    this.isLoading = true;

    this.loader?.classList.remove(
      'hidden'
    );

    this.icon?.classList.add(
      'hidden'
    );

  }

  hideLoader() {

    this.isLoading = false;

    this.loader?.classList.add(
      'hidden'
    );

    this.icon?.classList.remove(
      'hidden'
    );

  }

  async handleFetch() {

    try {

      const response =
        await fetch(
          this.productUrl
        );

      if (!response.ok) {
        throw new Error(
          'Failed to load product'
        );
      }

      const htmlString =
        await response.text();

      const temp =
        document.createElement(
          'div'
        );

      temp.innerHTML =
        htmlString;

      const updatedHTML =
        temp.querySelector(
          '.pdp-product-shell'
        );

      if (!updatedHTML) {
        throw new Error(
          'Product frame not found'
        );
      }

      const productInfo =
        updatedHTML.querySelector(
          'pdp-product-shell'
        );

      if (!productInfo) {
        throw new Error(
          'Product shell not found'
        );
      }

      const originalSectionId =
        productInfo.dataset.sectionId;

      const updatedSectionId =
        `quick-add-${originalSectionId}`;

      updatedHTML.innerHTML =
        updatedHTML.innerHTML.replaceAll(
          originalSectionId,
          updatedSectionId
        );

      const quickViewProductInfo =
        updatedHTML.querySelector(
          'pdp-product-shell'
        );

      if (
        quickViewProductInfo
      ) {

        quickViewProductInfo.dataset.originalSectionId =
          originalSectionId;

        quickViewProductInfo.dataset.sectionId =
          updatedSectionId;

        quickViewProductInfo.dataset.mainSectionId =
          updatedSectionId;

        quickViewProductInfo.dataset.updateUrl =
          'false';

      }

      updatedHTML
        .querySelectorAll(
          '.accordion_item button'
        )
        .forEach((button) => {

          button.setAttribute(
            'tabindex',
            '-1'
          );

        });

      updatedHTML
        .querySelector(
          'sticky-cart'
        )
        ?.remove();

      if (this.drawer) {

        this.drawer.innerHTML =
          updatedHTML.innerHTML;

      }

      requestAnimationFrame(
        () => {

          openPanel(
            this.mainDrawer,
            this._triggerButton || this.querySelector('button')
          );

        }
      );

    } catch (error) {

      console.error(
        'Quick View Error:',
        error
      );

    } finally {

      this.hideLoader();

    }

  }

}

customElements.define(
  'quick-add-button',
  QuickAddButton
);


class SizeChart extends HTMLElement {   
  connectedCallback() { 
    this.trigger = this.querySelector(".size_chart_wrapper");
    this.popup = document.querySelector(".pdp_size_ch_wrapper");
    
    if (!this.trigger || !this.popup) return;
   
    this.inner = this.popup.querySelector(".pdp_size_ch_inner");
    this.closeBtn = this.popup.querySelector(".pdp_size_ch_close");
    this.sections = document.querySelectorAll(".shopify-section");
    this.focusableSelectors =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.lastFocusedElement = null;

    this.popup.setAttribute("role", "dialog");
    this.popup.setAttribute("aria-modal", "true");
    this.popup.setAttribute("aria-hidden", "true");
    this.popup.tabIndex = -1;
    if (this.inner && !this.inner.hasAttribute("tabindex")) {
      this.inner.setAttribute("tabindex", "-1");
    }

    if (this.closeBtn && this.closeBtn.tagName !== "BUTTON") {
      this.closeBtn.setAttribute("role", "button");
      this.closeBtn.setAttribute("tabindex", "0");
      this.closeBtn.setAttribute("aria-label", "Close size chart");
    }

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleCloseBtnKeydown = this.handleCloseBtnKeydown.bind(this);

    this.trigger.addEventListener("click", this.open);
    this.popup.addEventListener("click", this.close);
    this.popup.addEventListener("keydown", this.handleKeydown);
    this.inner?.addEventListener("click", this.stopPropagation);
    this.closeBtn?.addEventListener("click", this.close);
    this.closeBtn?.addEventListener("keydown", this.handleCloseBtnKeydown);
  }

  getFocusableElements() {
    if (!this.inner) return [];

    return [...this.inner.querySelectorAll(this.focusableSelectors)].filter(
      (el) => !el.disabled && el.offsetParent !== null
    );
  }

  trapFocus(e) {
    const focusables = this.getFocusableElements();

    if (!focusables.length) {
      e.preventDefault();
      this.inner?.focus();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || !this.inner.contains(active)) {
        e.preventDefault();
        last.focus();
      }
      return;
    }

    if (active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  handleKeydown(e) {
    if (!this.popup.classList.contains("active")) return;

    if (e.key === "Escape") {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key === "Tab") {
      this.trapFocus(e);
    }
  }

  handleCloseBtnKeydown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.close();
    }
  }

  open(e) {
    e.preventDefault();

    this.lastFocusedElement = document.activeElement;

    this.popup.classList.add("active");
    this.popup.setAttribute("aria-hidden", "false");

    this.sections.forEach((section) => {
      section.style.zIndex = "unset";
    });

    const focusables = this.getFocusableElements();
    if (focusables.length) {
      focusables[0].focus();
    } else {
      this.inner?.focus();
    }

    document.body.setAttribute("data-scroll-locked", "true");
    document.body.style.overflow = "hidden";

    window.whenLenisReady(lenis => {
      lenis.stop();
    });
  }

  close() {
    this.popup.classList.remove("active");
    this.popup.setAttribute("aria-hidden", "true");

    this.sections.forEach((section) => {
      section.style.removeProperty("z-index");
    });

    const header = document.querySelector(
      ".shopify-section-group-header-group.header-section"
    );
    const announcement = document.querySelector(
      ".shopify-section-group-header-group.announcement-bar"
    );

    if (header) header.style.removeProperty("z-index");
    if (announcement) announcement.style.removeProperty("z-index");

    document.body.removeAttribute("data-scroll-locked");
    document.body.style.overflow = "";

    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === "function") {
      this.lastFocusedElement.focus();
    }

    window.whenLenisReady(lenis => {
      lenis.start();
    });
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.open);
    this.popup?.removeEventListener("click", this.close);
    this.popup?.removeEventListener("keydown", this.handleKeydown);
    this.inner?.removeEventListener("click", this.stopPropagation);
    this.closeBtn?.removeEventListener("click", this.close);
    this.closeBtn?.removeEventListener("keydown", this.handleCloseBtnKeydown);
  }
}
 
customElements.define("size-chart", SizeChart); 




class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;

    this.spacing = Number(this.dataset.spacing);
    this.columns = Number(this.dataset.columns);
    this.mobColumns = Number(this.dataset.mobColumns);
    this.tabColumns = Number(this.dataset.tabColumns);
    this.midColumns = Number(this.dataset.midColumns);

    this.swiper = null;
  }

  connectedCallback() {
    this.loadRecommendedProducts(
      this.recommendedURL,
      this.productId,
      this.sectionId
    );
  }

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(
      `${recommendedURL}&product_id=${productId}&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement('div');
        html.innerHTML = data;

        const recommendedProducts =
          html.querySelector('product-recommendations');

        if (!recommendedProducts?.innerHTML.trim().length) return;

        this.innerHTML = recommendedProducts.innerHTML;

        this.productsInner =
          this.querySelector('.product-complementary-inner') ||
          this.querySelector('.product_recommendations_inner') ||
          this.querySelector('.complementary_products_inner');

        this.initRecommendedSlider();

        document.dispatchEvent(
          new CustomEvent('RecommendedProductsUpdated')
        );
      });
  }

  initRecommendedSlider() {
    const inner = this.productsInner;

    if (!inner) return;

    window.whenSwiperReady(() => {
      this.swiper?.destroy(true, true);

      const prevBtn =
        inner.querySelector('.swiper-main-button-prev') ||
        this.querySelector('.swiper-main-button-prev');

      const nextBtn =
        inner.querySelector('.swiper-main-button-next') ||
        this.querySelector('.swiper-main-button-next');

      const scrollbar =
        inner.querySelector('.swiper-scrollbar') ||
        this.querySelector('.swiper-scrollbar');

      this.swiper = new Swiper(inner, {
        slidesPerView: this.columns,
        spaceBetween: this.spacing,

        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        },

        scrollbar: {
          el: scrollbar,
          draggable: true,
          hide: false
        },

        observer: true,
        observeParents: true,

        breakpoints: {
          0: {
            slidesPerView: this.mobColumns,
            spaceBetween: this.spacing
          },
          768: {
            slidesPerView: this.tabColumns,
            spaceBetween: this.spacing
          },
          1280: {
            slidesPerView: this.midColumns,
            spaceBetween: this.spacing
          },
          1400: {
            slidesPerView: this.columns,
            spaceBetween: this.spacing
          }
        }
      });

      this.swiper.navigation?.update();
      this.swiper.update();
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

customElements.define(
  'product-recommendations',
  ProductRecommendations
);

class AccordionTab extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion_item');
  }

  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.initializeAccordions();
  }

  initializeAccordions() {
    if (!this.items.length || !this.section) return;

    this.items.forEach(item => {
      const header = item.querySelector('.accordion_header');
      const content = item.querySelector('.accordion_content');

      if (!header || !content) return;

      // Preserve default open state
      if (item.classList.contains('open')) {
        content.style.height = `${content.scrollHeight}px`;
      } else {
        content.style.height = '0px';
      }

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        // Close ALL other accordions in the SAME section
        this.section
          .querySelectorAll('.accordion_item.open')
          .forEach(otherItem => {
            if (otherItem !== item) {
              const otherContent = otherItem.querySelector('.accordion_content');
              if (otherContent) {
                this.closeAccordion(otherItem, otherContent);
              }
            }
          });

        // Toggle current accordion
        if (isOpen) {
          this.closeAccordion(item, content);
        } else {
          this.openAccordion(item, content);
        }
      });
    });
  }

  openAccordion(item, content) {
    content.style.height = `${content.scrollHeight}px`;
    item.classList.add('open');
  }

  closeAccordion(item, content) {
    content.style.height = '0px';
    item.classList.remove('open');
  } 
}

customElements.define('accordion-tab', AccordionTab);


 
class DealCountdown extends HTMLElement { 
  connectedCallback() {
    const endDateStr = this.dataset.end;

    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    let parsed = new Date(endDateStr);
    let time = parsed.getTime();

    if (!endDateStr || isNaN(time)) {
      this.endTime = null;
    } else {
      this.endTime = time;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    if (!this.endTime) {
      this.setZero();
      return;
    }

    const now = Date.now();
    let diff = this.endTime - now;

    if (diff <= 0 || isNaN(diff)) {
      this.setZero();
      clearInterval(this.interval);
      return;
    }

    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / 1000 / 60) % 60);
    const s = Math.floor((diff / 1000) % 60);

    this.daysEl.textContent = String(d).padStart(2, '0');
    this.hoursEl.textContent = String(h).padStart(2, '0');
    this.minutesEl.textContent = String(m).padStart(2, '0');
    this.secondsEl.textContent = String(s).padStart(2, '0');
  }

  setZero() {
    this.daysEl.textContent = '00';
    this.hoursEl.textContent = '00';
    this.minutesEl.textContent = '00';
    this.secondsEl.textContent = '00';
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('deal-countdown', DealCountdown);


class ScrollReveal {
	constructor(selector = ".reveal", staggercascade = 300) {
		this.selector = selector, this.staggercascade = staggercascade, this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
			root: null,
			threshold: .2
		}), this.initElements()
	}
	initElements(scope = document) {
		scope.querySelectorAll(this.selector).forEach(el => {
			el.dataset.revealed !== "true" && (el.style.opacity = 0, el.style.transform = "translateY(20px)", el.style.transition = "opacity 0.4s ease, transform 0.4s ease", this.observer.observe(el))
		})
	}
	staggerBatch(elements) {
		elements.forEach((el, index) => {
			setTimeout(() => {
				el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.revealed = "true"
			}, index * this.staggercascade), this.observer.unobserve(el)
		})
	}
	onIntersect(entries, observer) {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return;
			const el = entry.target;
			if (el.classList.contains("cascade")) {
				const siblings = Array.from(el.parentNode.querySelectorAll(".reveal.cascade")).filter(sib => sib.dataset.revealed !== "true");
				this.staggerBatch(siblings)
			} else el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.revealed = "true", observer.unobserve(el)
		})
	}
}
let scrollReveal;
document.addEventListener("DOMContentLoaded", () => {
	scrollReveal = new ScrollReveal(".reveal", 150)
}), document.addEventListener("shopify:section:load", () => {
	scrollReveal = new ScrollReveal(".reveal", 150)
});



class FadeObserver {
  constructor() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
  }

  observeElements(selector = '.fade-section') {
    document.querySelectorAll(selector).forEach(el => {
      this.observer.observe(el);
    });
  }
}

let fadeObserver;
document.addEventListener("DOMContentLoaded", () => {
  fadeObserver = new FadeObserver();
  fadeObserver.observeElements();
});
// Theme Editor re-renders sections without a page reload, producing a fresh
// `.fade-section` with no `is-visible`. Re-observe so the reveal still fires.
document.addEventListener("shopify:section:load", () => {
  fadeObserver = new FadeObserver();
  fadeObserver.observeElements();
});



class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.items = [];
  }

  connectedCallback() {
    this.items = this.querySelectorAll(':scope > details');

    this.items.forEach((item) => {
      const summary = item.querySelector(':scope > summary');
      const content = item.querySelector(':scope > .accordion__content');

      if (!summary || !content) return;

      // initial state
      if (item.hasAttribute('open')) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
        content.style.overflow = 'hidden';
      }

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        // critical for nested accordions
        e.stopPropagation();

        const isOpen = item.hasAttribute('open');
        const singleOpen = this.dataset.singleOpen !== "false";

        // close siblings (same level only)
        if (singleOpen) {
          this.items.forEach((i) => {
            if (i !== item) this.close(i);
          });
        }

        if (isOpen) {
          this.close(item);
        } else {
          this.open(item);
        }
      });
    });
  }

  open(item) {
    const content = item.querySelector(':scope > .accordion__content');
    if (!content) return;

    item.setAttribute('open', true);

    content.style.overflow = 'hidden';
    content.style.height = '0px';

    const height = content.scrollHeight;

    requestAnimationFrame(() => {
      content.style.transition = 'height 300ms ease';
      content.style.height = height + 'px';
    });

    content.addEventListener(
      'transitionend',
      () => {
        content.style.height = '';
        content.style.overflow = '';
      },
      { once: true }
    );
  }

  close(item) {
    const content = item.querySelector(':scope > .accordion__content');
    if (!content) return;

    const height = content.scrollHeight;

    content.style.overflow = 'hidden';
    content.style.height = height + 'px';

    requestAnimationFrame(() => {
      content.style.transition = 'height 300ms ease';
      content.style.height = '0px';
    });

    content.addEventListener(
      'transitionend',
      () => {
        item.removeAttribute('open');
        content.style.height = '';
        content.style.overflow = '';
      },
      { once: true }
    );
  }
}

if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}


  class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.endDateStr = this.getAttribute('data-end-date');
    this.intervalId = null;
  }

  connectedCallback() {
    // If no end-date is set, use 7 days from now
    if (!this.endDateStr) {
      const now = new Date();
      const future = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      this.endDate = future;
    } else {
      this.endDate = new Date(this.endDateStr);
    }

    this.init();
  }

  init() {
    this.daysEl = this.querySelector('#days-' + this.sectionId);
    this.hoursEl = this.querySelector('#hours-' + this.sectionId);
    this.minutesEl = this.querySelector('#minutes-' + this.sectionId);
    this.secondsEl = this.querySelector('#seconds-' + this.sectionId);

    this.updateTimer();
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();
    const timeRemaining = this.endDate - now;

    if (timeRemaining <= 0) {
      this.daysEl.textContent = '00';
      this.hoursEl.textContent = '00';
      this.minutesEl.textContent = '00';
      this.secondsEl.textContent = '00';
      clearInterval(this.intervalId);
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    this.daysEl.textContent = days.toString().padStart(2, '0');
    this.hoursEl.textContent = hours.toString().padStart(2, '0');
    this.minutesEl.textContent = minutes.toString().padStart(2, '0');
    this.secondsEl.textContent = seconds.toString().padStart(2, '0');
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
if (!customElements.get('countdown-timer')) {
customElements.define('countdown-timer', CountdownTimer);
}

  
// VIDEO BACKGROUND
class VideoBackground extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector('.video_background_inner');
    this.sticky = this.querySelector('.video_bg_vdo_wrapper');

    this.start = 0;
    this.animEnd = 0;
    this.holdEnd = 0;

    /* animation tuning */
    this.textRevealAt = 0.2;
    this.holdScroll = 1;

    this.ctaLinks = [];

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
  }

  connectedCallback() {
    if (!this.wrapper || !this.sticky) return;

    this.initializeFocusState();
    this.calculate();
    this.onScroll();

    this.addEventListener('focusin', this.handleFocusIn);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('layout:updated', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('layout:updated', this.onResize);

    this.removeEventListener('focusin', this.handleFocusIn);
  }

  onResize() {
    requestAnimationFrame(() => {
      this.calculate();
      this.onScroll();
    });
  }

  calculate() {
    const rect = this.wrapper.getBoundingClientRect();

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    this.start = rect.top + scrollTop;

    /* animation takes first viewport */
    this.animEnd = this.start + window.innerHeight;

    /* hold phase */
    this.holdEnd =
      this.animEnd +
      window.innerHeight * this.holdScroll;
  }

  onScroll() {

    /* disable effect on mobile */
    if (window.innerWidth <= 640) {
      this.sticky.style.transform = '';
      this.classList.add('is-complete');
      this.syncCtaFocus();
      return;
    }

    const scrollY = window.scrollY;

    /* animation phase */
    const animProgress = Math.min(
      Math.max(
        (scrollY - this.start) /
        (this.animEnd - this.start),
        0
      ),
      1
    );

    const translateY =
      200 - 200 * animProgress;

    const scale =
      0.4 + 0.6 * animProgress;

    this.sticky.style.transform =
      `scale(${scale})`;

    /* reveal text */
    if (animProgress >= this.textRevealAt) {
      this.classList.add('is-complete');
    } else {
      this.classList.remove('is-complete');
    }

    this.syncCtaFocus();

    /* hold phase */
    if (
      scrollY >= this.animEnd &&
      scrollY <= this.holdEnd
    ) {
      this.sticky.style.transform =
        `translateY(0) scale(1)`;
    }
  }

  initializeFocusState() {
    this.ctaLinks = [
      ...this.querySelectorAll('[data-video-bg-cta]')
    ];

    this.ctaLinks.forEach((link) => {

      if (link.hasAttribute('href')) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }

    });
  }

  syncCtaFocus() {
    this.ctaLinks.forEach((link) => {

      if (link.hasAttribute('href')) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }

    });
  }

  handleFocusIn(e) {
    /*
     * Keyboard users can tab to links/buttons inside the text wrapper before
     * the scroll-driven animation has completed. While incomplete the wrapper
     * is opacity:0 / pointer-events:none, so the focused element is invisible
     * (accessibility failure). When focus lands on any content inside the text
     * wrapper, fully complete the animation so the focused element is visible.
     */
    if (!e.target.closest('.video_bg_text_wrapper')) {
      return;
    }

    this.completeAnimation();
  }

  completeAnimation() {
    if (!this.classList.contains('is-complete')) {
      this.classList.add('is-complete');
    }

    /* snap the video to its final, fully-animated state */
    if (this.sticky) {
      this.sticky.style.transform = 'translateY(0) scale(1)';
    }

    this.syncCtaFocus();
  }
}

customElements.define(
  'video-background',
  VideoBackground
);


class ShopLook extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll('.look-hotspot');
    this.details = this.querySelectorAll('.look-details');
    this.bundleForm = this.querySelector('.bundle-form');
    this.bundleButton = this.querySelector('.shop_bundle_button');
    this.bundleLoader = this.bundleButton ? this.bundleButton.querySelector('.form_loader') : null;
    this.errorNode = null;
    this.bundleSwiper = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.bundleSwiper) {
      this.bundleSwiper.destroy(true, true);
      this.bundleSwiper = null;
    }
  }

  init() {
    this.hotspots.forEach((hotspot) => {
      const button = hotspot.querySelector('.hotspot-marker');
      if (!button) return;

      const id = hotspot.classList[1];
      const detail = this.querySelector(`.look-details[data-show="${id}"]`);
      if (!detail) return;

      // Accessibility attributes
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', id);

      detail.setAttribute('role', 'dialog');
      detail.setAttribute('aria-hidden', 'true');

      // Click event
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle(hotspot, detail, button);
      });

      // Keyboard support
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle(hotspot, detail, button);
        }
      });
    });

    // Close when clicking outside (but not on hotspot or product)
    document.addEventListener('click', (e) => {
      const isHotspot = e.target.closest('.look-hotspot');
      const isProduct = e.target.closest('.look-details');

      if (!isHotspot && !isProduct) {
        this.closeAll();
      }
    });

    // Escape key closes all
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAll();
      }
    });

    // Close button inside product
    this.details.forEach((detail) => {
      const closeBtn = detail.querySelector('.look-shop-close');

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.closeAll();
        });
      }
    });

    this.bindBundleSelection();
    this.bindCardSelection();
    this.bindBundleSubmit();
    this.updateBundleButtonState();
    this.initBundleSwiper();
  }

  initBundleSwiper() {
    const sliderEl = this.querySelector('.shop_items_wrap.swiper');
    if (!sliderEl || sliderEl.swiper || this.bundleSwiper) {
      return;
    }

    const setup = () => {
      if (!window.Swiper || !this.isConnected || sliderEl.swiper || this.bundleSwiper) {
        return;
      }

      const nextButton = this.querySelector(
        '.shop_the_look_nav.swiper-button-next'
      );

      const prevButton = this.querySelector(
        '.shop_the_look_nav.swiper-button-prev'
      );

      this.bundleSwiper = new Swiper(sliderEl, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        speed: 500,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          640: {
            slidesPerView: 2.2,
            spaceBetween: 14,
          },
          992: {
            slidesPerView: 3.2,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 4.5,
            spaceBetween: 16,
          }
        }
      });
    };

    if (typeof window.whenSwiperReady === 'function') {
      window.whenSwiperReady(setup);
    } else {
      setup();
    }
  }

  bindBundleSelection() {
    this.addEventListener('click', (event) => {
      const addButton = event.target.closest('.shop_add_button');

      if (!addButton || !this.contains(addButton)) {
        return;
      }

      event.preventDefault();

      const details = addButton.closest('.look-details');
      if (!details) {
        return;
      }

      const bundleIndex = details.dataset.bundleIndex;
      if (typeof bundleIndex === 'undefined') {
        return;
      }

      const inputs = this.getBundleInputs(bundleIndex);
      if (!inputs.length) {
        return;
      }

      const shouldEnable = inputs[0].disabled;
      this.setBundleItemState(bundleIndex, shouldEnable);
      this.syncAddButton(bundleIndex, shouldEnable);
      this.updateBundleButtonState();
    });
  }

  bindCardSelection() {
    this.querySelectorAll('.shop_product_card[data-bundle-index]').forEach((card) => {
      /*
       * Cards are selectable on click but are plain <div>s, so keyboard users
       * can neither focus nor toggle them. Expose available cards as toggle
       * buttons (focusable + Enter/Space activation + aria-pressed) so keyboard
       * behaviour matches the mouse click. Unavailable cards stay inert.
       */
      if (card.dataset.available !== 'false') {
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');

        const inputs = this.getBundleInputs(card.dataset.bundleIndex);
        const isSelected = inputs.length ? !inputs[0].disabled : false;
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      }

      card.addEventListener('click', (e) => {
        if (e.target.closest('a, button')) return;
        this.toggleBundleCard(card);
      });

      card.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        if (e.target.closest('a, button')) return;
        e.preventDefault(); /* prevent Space from scrolling the page */
        this.toggleBundleCard(card);
      });
    });
  }

  toggleBundleCard(card) {
    if (card.dataset.available === 'false') return;

    const bundleIndex = card.dataset.bundleIndex;
    if (typeof bundleIndex === 'undefined') return;

    const inputs = this.getBundleInputs(bundleIndex);
    if (!inputs.length) return;

    const shouldEnable = inputs[0].disabled;
    this.setBundleItemState(bundleIndex, shouldEnable);
    this.syncAddButton(bundleIndex, shouldEnable);
    this.updateBundleButtonState();

    card.setAttribute('aria-pressed', shouldEnable ? 'true' : 'false');
  }

  syncAddButton(bundleIndex, isSelected) {
    const detail = this.querySelector(`.look-details[data-bundle-index="${bundleIndex}"]`);
    if (!detail) return;

    const addButton = detail.querySelector('.shop_add_button');
    if (!addButton) return;

    addButton.classList.toggle('is-selected', isSelected);
    addButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  }

  bindBundleSubmit() {
    if (!this.bundleForm) {
      return;
    }

    this.bundleForm.addEventListener('submit', this.handleBundleSubmit.bind(this));
  }

  getBundleInputs(bundleIndex) {
    if (!this.bundleForm) {
      return [];
    }

    return Array.from(this.bundleForm.querySelectorAll(`input[name^="items[${bundleIndex}]"]`));
  }

  setBundleItemState(bundleIndex, isEnabled) {
    const inputs = this.getBundleInputs(bundleIndex);

    inputs.forEach((input) => {
      input.disabled = !isEnabled;
    });

    const bundleCard = this.querySelector(`.shop_product_card[data-bundle-index="${bundleIndex}"]`);
    if (bundleCard) {
      bundleCard.classList.toggle('is-selected', isEnabled);
    }

    const detail = this.querySelector(`.look-details[data-bundle-index="${bundleIndex}"]`);
    if (detail) {
      const hotspot = this.querySelector(`.${detail.dataset.show}`);
      if (hotspot) hotspot.classList.toggle('is-bundle-selected', isEnabled);
    }
  }

  getSelectedBundleItems() {
    if (!this.bundleForm) {
      return [];
    }

    const formData = new FormData(this.bundleForm);
    const grouped = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (!match) {
        continue;
      }

      const index = match[1];
      const field = match[2];

      if (!grouped[index]) {
        grouped[index] = {};
      }

      grouped[index][field] = value;
    }

    return Object.values(grouped)
      .filter((item) => item.id)
      .map((item) => ({
        id: item.id,
        quantity: Number(item.quantity || 1)
      }));
  }

  updateBundleButtonState() {
    if (!this.bundleButton) {
      return;
    }

    const hasItems = this.getSelectedBundleItems().length > 0;
    this.bundleButton.disabled = !hasItems;
  }

  getErrorNode() {
    if (this.errorNode) {
      return this.errorNode;
    }

    if (!this.bundleForm) {
      return null;
    }

    const node = document.createElement('div');
    node.className = 'bundle_form_error';
    this.bundleForm.appendChild(node);
    this.errorNode = node;
    return node;
  }

  showBundleError(message) {
    const node = this.getErrorNode();

    if (!node) {
      return;
    }

    node.textContent = message;
    node.classList.add('show');

    setTimeout(() => {
      node.classList.remove('show');
    }, 2500);
  }

  async handleBundleSubmit(event) {
    event.preventDefault();

    const items = this.getSelectedBundleItems();

    if (!items.length) {
      this.updateBundleButtonState();
      return;
    }

    if (this.bundleButton) {
      this.bundleButton.disabled = true;
      this.bundleButton.classList.add('is-loading');
    }

    if (this.bundleLoader) {
      this.bundleLoader.classList.remove('hidden');
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();

      if (!response.ok) {
        const message = data.description || data.message || 'Unable to add selected bundle items.';

        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: {
              sections: rawCartData,
              message
            },
            bubbles: true
          })
        );

        throw new Error(message);
      }

      const cartDrawer = document.querySelector('theme-cart-drawer');

      if (cartDrawer) {
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: {
              sections: rawCartData,
              button: this.bundleButton
            },
            bubbles: true
          })
        );
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    } catch (error) {
      if (error && error.message) {
        this.showBundleError(error.message);
      }
    } finally {
      if (this.bundleButton) {
        this.bundleButton.classList.remove('is-loading');
      }

      if (this.bundleLoader) {
        this.bundleLoader.classList.add('hidden');
      }

      this.updateBundleButtonState();
    }
  }

  toggle(activeHotspot, activeDetail, activeButton) {
    const isOpen = activeDetail.classList.contains('active');

    this.closeAll();

    if (!isOpen) {
      activeDetail.classList.add('active');
      activeHotspot.classList.add('active');

      activeButton.setAttribute('aria-expanded', 'true');
      activeDetail.setAttribute('aria-hidden', 'false');
    }
  }

  closeAll() {
    this.hotspots.forEach((hotspot) => {
      const button = hotspot.querySelector('.hotspot-marker');
      const id = hotspot.classList[1];
      const detail = this.querySelector(`.look-details[data-show="${id}"]`);

      if (detail) {
        detail.classList.remove('active');
        detail.setAttribute('aria-hidden', 'true');
      }

      hotspot.classList.remove('active');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

customElements.define('shop-looks', ShopLook);

class ScrollingCardLayered extends HTMLElement {

  constructor() {
    super();

    this.cards =
      this.querySelectorAll(
        '.scrolling-card-item'
      );

    this.onScroll =
      this.onScroll.bind(this);

    this.onResize =
      this.onResize.bind(this);

    this.onPageShow =
      this.onPageShow.bind(this);

    this.scheduleUpdate =
      this.scheduleUpdate.bind(this);

    this.cardData = [];

    this.resizeTimer = null;

    this.rafId = null;

    this.imageLoadHandlers = [];
  }

  connectedCallback() {

    if (!this.cards.length) return;

    const init = () => {

      requestAnimationFrame(() => {

        this.calculateCards();

        this.scheduleUpdate();

      });

    };

    /* initial */
    init();

    /* after full load */
    window.addEventListener(
      'load',
      init,
      { once: true }
    );

    window.addEventListener(
      'pageshow',
      this.onPageShow
    );

    /* resize */
    window.addEventListener(
      'resize',
      this.onResize
    );

    /* scroll */
    window.addEventListener(
      'scroll',
      this.onScroll,
      { passive: true }
    );

    this.bindImageLoad();

  }

  disconnectedCallback() {

    window.removeEventListener(
      'scroll',
      this.onScroll
    );

    window.removeEventListener(
      'resize',
      this.onResize
    );

    window.removeEventListener(
      'pageshow',
      this.onPageShow
    );

    clearTimeout(this.resizeTimer);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    this.imageLoadHandlers.forEach(
      ({ image, handler }) => {
        image.removeEventListener('load', handler);
      }
    );

    this.imageLoadHandlers = [];

  }

  onPageShow() {

    this.calculateCards();

    this.scheduleUpdate();

  }

  onResize() {

    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(() => {

      this.calculateCards();

      this.scheduleUpdate();

    }, 100);

  }

  bindImageLoad() {

    this.imageLoadHandlers.forEach(
      ({ image, handler }) => {
        image.removeEventListener('load', handler);
      }
    );

    this.imageLoadHandlers = [];

    this.querySelectorAll('img').forEach((image) => {

      if (image.complete) return;

      const handler = () => {
        this.onResize();
      };

      image.addEventListener(
        'load',
        handler,
        { once: true }
      );

      this.imageLoadHandlers.push({
        image,
        handler
      });

    });

  }

  calculateCards() {

    this.cardData = [];

    const stack =
      this.querySelector('.scrolling-card-stack') ||
      this;

    const stackTop =
      stack.getBoundingClientRect().top +
      window.scrollY;

    this.cards.forEach((card, index) => {

      this.cardData.push({
        card,
        top: stackTop + card.offsetTop,
        height: card.offsetHeight,
        index
      });

    });

  }

  scheduleUpdate() {

    if (this.rafId) return;

    this.rafId = requestAnimationFrame(() => {

      this.rafId = null;

      this.updateCards();

    });

  }

  onScroll() {

    this.scheduleUpdate();

  }

  isNearViewport() {

    const rect =
      this.getBoundingClientRect();

    const viewportHeight =
      window.innerHeight;

    const buffer =
      viewportHeight * 1.5;

    return (
      rect.bottom > -buffer &&
      rect.top < viewportHeight + buffer
    );

  }

  updateCards() {

    if (!this.isNearViewport()) return;

    this.calculateCards();

    if (!this.cardData.length) return;

    const scrollTop =
      window.scrollY;

    const viewportHeight =
      window.innerHeight;

    this.cards.forEach(
      (card, index) => {

        const current =
          this.cardData[index];

        if (!current) return;

        const cardTop =
          current.top;

        const nextCard =
          this.cardData[index + 1];

        const start =
          cardTop -
          viewportHeight * 0.8;

        const end =
          nextCard
            ? nextCard.top -
              viewportHeight * 0.4
            : cardTop +
              Math.max(
                viewportHeight,
                current.height
              );

        const distance =
          Math.max(1, end - start);

        let progress =
          (
            scrollTop - start
          ) /
          distance;

        progress = Math.max(
          0,
          Math.min(1, progress)
        );

        const rotateDirection =
          index % 2 === 0 ? 1 : -1;

        const baseRotate =
          rotateDirection * 4;

        let rotate = 0;

        if (progress >= 1) {

          rotate = baseRotate;

        } else if (progress > 0) {

          rotate =
            baseRotate * progress;

        }

        card.style.transform =
          `rotate(${rotate}deg)`;


      }
    );

  }

}

if (!customElements.get('scrolling-card-layered')) {
  customElements.define(
    'scrolling-card-layered',
    ScrollingCardLayered
  );
}


  window.addEventListener('load', () => {
    const hero = document.querySelector('.hover-card-sticky');
    if (!hero) return;

    hero.classList.add('loaded');
  });
function heroViewedObserver() {
  const hero = document.querySelector('.hover-card-sticky');
  if (!hero) return;

  const nextSection = hero.nextElementSibling;
  if (!nextSection) return;

  function checkHero() {
    const nextTop = nextSection.getBoundingClientRect().top;

    if (nextTop <= 0) {
      hero.classList.add('viewed');
    } else {
      hero.classList.remove('viewed');
    }
  }

  window.addEventListener('scroll', checkHero);
  checkHero();
}

document.addEventListener('DOMContentLoaded', heroViewedObserver);
document.addEventListener('shopify:section:load', heroViewedObserver);

class ReviewCircle extends HTMLElement {

  constructor() {
    super();
    this.initialized = false;
    this.activeIndex = 0;
    this.rotationIndex = 0;
    this._userInteracted = false;
    // Bound so the same reference can be added/removed as an event listener.
    this._onEditorEvent = this._onEditorEvent.bind(this);
  }

  /* Query children on connect (not in the constructor) so the layout always
     reflects the current DOM after a Theme Editor re-render. */
  cacheElements() {
    this.nav = this.querySelector('.review-circle-nav');
    this.track = this.querySelector('.review-circle-track');
    this.items = this.querySelectorAll('.review-circle-avatar');
    this.reviews = this.querySelectorAll('.review-circle-review');
  }

  connectedCallback() {
    this.initialized = true;
    this._userInteracted = false;

    this.cacheElements();

    if (!this.items.length) return;

    this.bindEvents();

    /* Defer to the next frame so the section is laid out and clientWidth is
       valid — otherwise the orbit radius is computed from stale/zero sizes. */
    requestAnimationFrame(() => {
      this.positionItems();
      this.update();
    });

    this._ro = new ResizeObserver(() => {
      this.positionItems();
      this.update();
    });

    this._ro.observe(this.nav || this);

    /* In the Theme Editor the page isn't reloaded; recompute layout when
       Shopify re-renders / (de)selects this section or its blocks. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', this._onEditorEvent);
      document.addEventListener('shopify:section:select', this._onEditorEvent);
      document.addEventListener('shopify:block:select', this._onEditorEvent);
    }

  }

  disconnectedCallback() {

    if (this._ro) {
      this._ro.disconnect();
      this._ro = null;
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this._onEditorEvent);
      document.removeEventListener('shopify:section:select', this._onEditorEvent);
      document.removeEventListener('shopify:block:select', this._onEditorEvent);
    }

  }

  /* Layout-only recompute for Theme Editor events (no active-slide change). */
  _onEditorEvent(event) {
    if (!event.target || !event.target.contains(this)) return;

    // Re-cache in case blocks were added/removed, then recompute positions.
    this.cacheElements();

    if (!this.items.length) return;

    requestAnimationFrame(() => {
      this.positionItems();
      this.update();
    });
  }

  isLinearMode() {

    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;

  }

  /* Few blocks would land in the clipped lower half of the orbit, so on
     desktop lay them out along the visible top arc instead of a full ring. */
  isArcMode() {

    return (
      !this.isLinearMode() &&
      this.items &&
      this.items.length > 0 &&
      this.items.length <= 4
    );

  }

  bindEvents() {

    this.items.forEach((item) => {

      const activateItem = () => {
        const targetIndex = Number(item.dataset.index);
        const total = this.items.length;
        let delta = targetIndex - this.activeIndex;

        if (delta > total / 2) {
          delta -= total;
        } else if (delta < -total / 2) {
          delta += total;
        }

        this.rotationIndex += delta;
        this.activeIndex = targetIndex;
        this.update();
      };

      item.addEventListener(
        'click',
        () => { this._userInteracted = true; activateItem(); }
      );

      item.addEventListener(
        'focus',
        () => { this._userInteracted = true; activateItem(); }
      );

    });

  }

  update() {

    if (!this.track || !this.items || !this.items.length) return;

    const total =
      this.items.length;

    if (this.isLinearMode() || this.isArcMode()) {

      /* Arc/linear: avatars stay put; only the active state changes. */
      this.track.style.transform =
        'none';

      this.items.forEach((item) => {

        item.style.setProperty(
          '--counter-rotate',
          '0deg'
        );

      });

    } else {

      const rotate =
        -(
          360 / total
        ) *
        this.rotationIndex;

      /* rotate orbit */

      this.track.style.transform =
        `rotate(${rotate}deg)`;

      /* keep avatars upright */

      this.items.forEach((item) => {

        item.style.setProperty(
          '--counter-rotate',
          `${-rotate}deg`
        );

      });

    }

    this.updateContent();

    this.updateActive();

  }

  updateContent() {

    this.reviews.forEach((review) => {

      const isActive =
        Number(
          review.dataset.review
        ) === this.activeIndex;

      review.classList.toggle(
        'active',
        isActive
      );

      if (!isActive) {
        review.removeAttribute('data-lenis-prevent');
      } else {
        requestAnimationFrame(() => {
          if (review.scrollHeight > review.clientHeight) {
            review.setAttribute('data-lenis-prevent', '');
          } else {
            review.removeAttribute('data-lenis-prevent');
          }
        });
      }

    });

  }

  updateActive() {

    this.items.forEach((item) => {

      const isActive =
        Number(
          item.dataset.index
        ) === this.activeIndex;

      item.classList.toggle(
        'active',
        isActive
      );

      if (
        isActive &&
        this.isLinearMode() &&
        this._userInteracted
      ) {

        item.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });

      }

    });

  }

  positionItems() {

  if (!this.items || !this.items.length) return;

  const total = this.items.length;

  if (this.isLinearMode()) {

    this.items.forEach((item) => {
      item.style.left = 'auto';
      item.style.top = 'auto';
      item.style.transform = 'none';
    });

    return;

  }

  const angleStep = 360 / total;

  const navSize = this.nav?.clientWidth || 1070;
  const avatarSize = this.items[0]?.clientWidth || 100;

  const orbitScale =
    window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches
      ? 0.95
      : 0.85;

  const radius = Math.max(0, ((navSize - avatarSize) / 2) * orbitScale);

  const arcMode = this.isArcMode();
  const ARC_SPAN = 120;
  const arcGap = total > 1 ? ARC_SPAN / (total - 1) : 0;

  /* Reverse mode = visible crop-window shows the BOTTOM of the circle,
     so the "front" angle flips from -90 (top) to 90 (bottom). */
  const isReversed = this.classList.contains('review-circle--reverse');
  const baseAngle = isReversed ? 90 : -90;

  this.items.forEach((item, index) => {

    const angle = arcMode
      ? (total > 1 ? baseAngle - ARC_SPAN / 2 : baseAngle) + arcGap * index
      : (angleStep * index) + baseAngle;

    const radians = angle * (Math.PI / 180);

    const x = Math.cos(radians) * radius;
    const y = Math.sin(radians) * radius;

    item.style.left = '50%';
    item.style.top = '50%';

    item.style.transform = `
      translate(
        calc(-50% + ${x}px),
        calc(-50% + ${y}px)
      )
      rotate(var(--counter-rotate, 0deg))
    `;

  });

}

}

customElements.define(
  'review-circle',
  ReviewCircle
);

 
class MegaMenuTab extends HTMLElement {
  connectedCallback() {
    this.tabButtons     = [...this.querySelectorAll('button[data-tab]')];
    this.buttonWrappers = [...this.querySelectorAll('.mega_menu_tab_btns[data-tab]')];
    this.tabPanels      = [...this.querySelectorAll('.mega_menu_tab_products')];

    if (!this.tabButtons.length || !this.tabPanels.length) return;

    this.activate(0);

    this.tabButtons.forEach((btn, i) => {
      btn.addEventListener('mousedown', e => {
        if (!e.target.closest('a')) e.preventDefault();
      });

      btn.addEventListener('mouseenter', () => this.activate(i));

      btn.addEventListener('click', e => {
        if (e.target.closest('a')) return;
        e.preventDefault();
        this.activate(i);
        btn.blur(); // only reached by mouse clicks — keyboard is handled in keydown
      });

      btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // block synthetic click so blur() is never called
          this.activate(i);
          return;
        }
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const next = e.key === 'ArrowRight'
          ? (i === this.tabButtons.length - 1 ? 0 : i + 1)
          : (i === 0 ? this.tabButtons.length - 1 : i - 1);
        this.tabButtons[next].focus();
        this.activate(next);
      });
    });
  }

  activate(index) {
    this.buttonWrappers.forEach((wrapper, i) => {
      wrapper.classList.toggle('active', i === index);
    });

    this.tabButtons.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', active);
    });

    this.tabPanels.forEach((panel, i) => {
      const active = i === index;

      if (active) {
        panel.hidden = false;
        panel.offsetHeight;
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
        panel.addEventListener(
          'transitionend',
          () => { if (!panel.classList.contains('active')) panel.hidden = true; },
          { once: true }
        );
      }
    });
  }
}

customElements.define('mega-menu-tab', MegaMenuTab);


const PARALLAX_SELECTOR = "[data-animation]",
DISABLED_CLASS = "is-disabled",
MAIN_CONTENT_CLASS = "main-content",
SECTION_CLASS = "shopify-section",
PARALLAX_ATTR = "data-animation",
INTENSITY_ATTR = "data-animation-intensity",
STATIC_ATTR = "data-parallax-static",
SINGLE_ATTR = "data-parallax-single",
DISABLE_MOBILE_ATTR = "data-parallax-disable-on-mobile";

function getOrientation() {
	return window.innerWidth > window.innerHeight ? "landscape" : "portrait"
}

class ParallaxHandler {
	constructor(container) {
    this.container = container, this.percentage = 0, this.percentageFull = 0, this.animation = container.getAttribute("data-animation"), this.disableOnMobile = container.hasAttribute("data-animation-disable-on-mobile"), this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0), this.orientation = this.getOrientation(), this.scrollEvent = () => this.updateParallax(), this.resizeEvent = () => this.updateHeight(), this.lenisScrollEvent = () => this.updateParallax(), this.container.style.setProperty("--transformX-primary", "0%"), this.container.style.setProperty("--transformY-primary", "0%"), this.container.style.setProperty("--transformX-secondary", "0%"), this.container.style.setProperty("--transformY-secondary", "0%"), requestAnimationFrame(() => {
			this.containerHeight = container.offsetHeight, this.footerOffset = .15 * this.containerHeight, this.cachedPosition = this.footerOffset, this.cachedPercentage = 0, this.init()
		})
	}
	init() {
    this.updateParallax(), document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:load", this.resizeEvent), window.whenLenisReady && window.whenLenisReady(lenis => {
      lenis && typeof lenis.on == "function" && lenis.on("scroll", this.lenisScrollEvent)
    })
	}
	unload() {
    document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:load", this.resizeEvent), window.lenis && typeof window.lenis.off == "function" && window.lenis.off("scroll", this.lenisScrollEvent)
	}
	updateParallax() {
		if (this.container.classList.contains("is-disabled") || this.disableOnMobile && this.isMobile()) return;
    const scrollTop = window.scrollY || window.pageYOffset || 0,
			scrollBottom = scrollTop + this.viewportHeight;
    let containerTop = this.container.getBoundingClientRect().top + scrollTop;
		if (this.animation === "footer") {
			let sibling = document.getElementById("MainContent");
			sibling && (containerTop = Math.round(sibling.getBoundingClientRect().bottom + scrollTop))
		}
		const containerHeight = this.container.offsetHeight;
		if (containerTop < scrollBottom && containerTop + containerHeight >= scrollTop) {
      const visibleBottom = scrollBottom - containerTop;
      switch (this.percentage = 100 * (visibleBottom - containerHeight / 2) / this.viewportHeight, this.percentageFull = Number((visibleBottom / containerHeight).toFixed(2)), this.percentageVisible = Number((100 * visibleBottom / (this.viewportHeight + containerHeight)).toFixed(2)), this.animation) {
				case "circle":
					this.animateCircleText();
					break;
				case "horizontal":
				case "vertical":
				case "diagonal":
					this.animateOverlappingImages();
					break;
				case "offset-ltr":
				case "offset-rtl":
					this.applyOffsetX();
					break;
				case "zoom-on-scroll":
					this.zoomInOut();
					break;
				case "fade-in":
					this.fadeInOnScroll();
					break;
				case "blur":
					this.blurOutUntilCenter();
					break;
				case "footer":
					this.animateFooter();
					break
			}
		}
	}
	applyOffsetX() {
		const isStatic = this.container.hasAttribute("data-animation-static"),
      intensity = this.getIntensity();
		let baseOffset = this.animation === "offset-ltr" ? intensity : 0;
		isStatic && (baseOffset = intensity / 2);
		const direction = this.animation === "offset-ltr" ? 1 : -1,
			offset = intensity * this.percentageVisible / 100 - baseOffset;
		let finalOffset = Number(offset * direction).toFixed(2);
		finalOffset = Math.max(0, Math.min(1, finalOffset));
		const clamp = (n, min, max) => Math.max(min, Math.min(max, n)),
			value = 1 - clamp((this.percentageVisible - 40) / 60, 0, 1),
			scaleValue = 1.5 - clamp(this.percentageVisible, 0, 100) / 100;
		this.container.style.setProperty("--offsetX", `${value*1.2}`), this.container.style.setProperty("--scale", `${scaleValue*1.5}`)
	}
  getIntensity() {
    const raw = Number(this.container.getAttribute("data-animation-intensity"));
    return Number.isFinite(raw) ? raw : 100
  }
	animateCircleText() {
		const rotateAmount = 70 * this.percentage / 100 * 1;
		this.percentage > 0 && this.container.style.setProperty("--rotate", `${35+rotateAmount}deg`)
	}
	animateOverlappingImages() {
    const intensity = .25 * this.getIntensity(),
			halfIntensity = intensity / 2,
			isSingle = this.container.hasAttribute("data-animation-single"),
			value = intensity * this.percentage / 100;
		let xPrimary = 0,
			yPrimary = 0,
			xSecondary = 0,
			ySecondary = 0;
		["horizontal", "diagonal"].includes(this.animation) && (xPrimary = -halfIntensity + value, xSecondary = halfIntensity - value), ["vertical", "diagonal"].includes(this.animation) && (yPrimary = halfIntensity - value, ySecondary = -halfIntensity + value), this.container.style.setProperty("--transformX-primary", `${xPrimary}%`), this.container.style.setProperty("--transformY-primary", `${yPrimary}%`), isSingle || (this.container.style.setProperty("--transformX-secondary", `${xSecondary}%`), this.container.style.setProperty("--transformY-secondary", `${ySecondary}%`))
	}
	animateFooter() {
		const offset = this.footerOffset * this.percentageFull,
			percentage = Number(offset / this.footerOffset * 100).toFixed(2);
		let newY = Number(this.footerOffset - offset).toFixed(2);
		this.percentageFull >= 1 && (newY = 0), this.cachedPercentage !== percentage && (this.container.style.setProperty("--transformY", `${newY}`), this.cachedPercentage = percentage, this.cachedPosition = newY)
	}
	zoomInOut() {
		const scale = 1 + .2 * this.percentageVisible / 100,
			clampedScale = Math.max(scale, 1);
		this.container.style.setProperty("--scale", clampedScale.toFixed(4))
	}
	fadeInOnScroll() {
		const viewportCenter = this.viewportHeight / 2,
			rect = this.container.getBoundingClientRect(),
			start = this.viewportHeight,
			end = viewportCenter - rect.height / 2,
			current = rect.top;
		let progress = (start - current) / (start - end);
		progress = Math.max(0, Math.min(1, progress)), this.container.style.setProperty("--opacity", progress.toFixed(4))
	}
	blurOutUntilCenter() {
		const viewportCenter = this.viewportHeight / 2,   
			rect = this.container.getBoundingClientRect(),
			start = this.viewportHeight,
			end = viewportCenter - rect.height / 2,
			current = rect.top;
		let progress = (start - current) / (start - end);
		progress = Math.max(0, Math.min(1, progress));
		const blur = (1 - progress) * 10;
		this.container.style.setProperty("--blur", `${blur.toFixed(2)}px`)
	} 
	updateHeight() { 
		const isDesktop = matchMedia("(min-width: 1024px)").matches;
		(this.orientation !== this.getOrientation() || isDesktop) && (this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)), this.containerHeight = this.container.offsetHeight, this.orientation = this.getOrientation())
	}
	getOrientation() {
		return window.innerWidth > window.innerHeight ? "landscape" : "portrait"
	}
	isMobile() {
		return /Mobi|Android/i.test(navigator.userAgent)
	}
}
window.ParallaxHandler = ParallaxHandler;


window.addEventListener("scroll", () => {
  document.dispatchEvent(new Event("theme:scroll"));
});
 
window.addEventListener("resize", () => {
  document.dispatchEvent(new Event("theme:resize"));
});

window.addEventListener("load", () => {
  document.dispatchEvent(new Event("theme:load"));
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-animation]").forEach((el) => {
    new ParallaxHandler(el);
  });
});


class RichIconBlock extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    window.whenSwiperReady(() => {
      this.init();
    });
  }

  init() {
    const sliderEl = this.querySelector('.swiper');

    if (!sliderEl || sliderEl.swiper) return;

    const wrapper = sliderEl.querySelector('.swiper-wrapper');

    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');

    
    const nextBtn =
      this.querySelector('.swiper-button-next');

    const prevBtn =
      this.querySelector('.swiper-button-prev');

    this.swiper = new Swiper(sliderEl, {
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 800,
      loop: false,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },

      observer: true,
      observeParents: true,
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this._initialized = false;
  }
}

customElements.define(
  'rich-icon-block',
  RichIconBlock
);


class TagFilterCode extends HTMLElement {
      connectedCallback() {
        this._sectionId = this.dataset.sectionId;
        this._btn = this.querySelector(`#tagFilterBtn-${this._sectionId}`);
        this._d1  = this.querySelector(`#tagDropdown1-${this._sectionId}`);
        this._d2  = this.querySelector(`#tagDropdown2-${this._sectionId}`);

        if (!this._btn || !this._d1 || !this._d2) return;

        this._btn.addEventListener('click', () => {
          const t1 = this._d1.value;
          const t2 = this._d2.value;
          if (!t1 && !t2) return;

          let url = '/collections/all';
          if (t1 && t2)     url += `/${t1}+${t2}`;
          else if (t1)      url += `/${t1}`;
          else              url += `/${t2}`;

          window.location.href = url;
        });
      }
    }

customElements.define('tag-filter-code', TagFilterCode);
  
class DialogComponent extends HTMLElement {
  constructor() {
    super();
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('[data-landing]');
    this.wrapper = this.querySelector('.dailogue_wrapper');

    if (!this.container || !this.wrapper) return;

    this.addEventListener('click', (e) => {

      // OPEN
      const trigger = e.target.closest('[data-target]');
      if (trigger && this.contains(trigger)) {
        e.preventDefault();
        this.open(trigger);
        return;
      }

      // CLOSE BUTTON
      if (e.target.closest('.dialog__close')) {
        this.close();
        return;
      }

      // CLICK OUTSIDE
      if (!e.target.closest('.dailogue_wrapper')) {
        this.close();
      }
    });
  }

  open(triggerBtn) {
    this.lastFocused = triggerBtn || document.activeElement;

    this.container.classList.add('active');

    this.focusableEls = this.getFocusable(this.wrapper);

    let target =
      this.wrapper.querySelector('input:not([type="hidden"])') ||
      this.wrapper.querySelector('.dialog__close') ||
      this.focusableEls[0];

    if (!target) {
      this.wrapper.setAttribute('tabindex', '-1');
      target = this.wrapper;
    }

    requestAnimationFrame(() => {
      target.focus();
    });

    document.addEventListener('keydown', this.handleKeydown);
  }

  close() {
    this.container.classList.remove('active');

    document.removeEventListener('keydown', this.handleKeydown);

    if (this.lastFocused) {
      this.lastFocused.focus();
      this.lastFocused = null;
    }
  }

  getFocusable(scope) {
    return Array.from(
      scope.querySelectorAll(`
        a[href],
        button:not([disabled]),
        input:not([type="hidden"]):not([disabled]),
        select:not([disabled]),
        textarea:not([disabled]),
        [tabindex]:not([tabindex="-1"])
      `)
    ).filter(el => el.offsetParent !== null);
  }

  handleKeydown(e) {
    if (!this.container.classList.contains('active')) return;

    // ESC CLOSE
    if (e.key === 'Escape') {
      this.close();
      return;
    }

    if (e.key !== 'Tab') return;

    this.focusableEls = this.getFocusable(this.wrapper);

    if (!this.focusableEls.length) return;

    const first = this.focusableEls[0];
    const last = this.focusableEls[this.focusableEls.length - 1];

    // SINGLE ELEMENT CASE
    if (this.focusableEls.length === 1) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}

if (!customElements.get('dailog-component')) {
  customElements.define('dailog-component', DialogComponent);
}


// --------------------------Varient---------------------------


document.addEventListener("click", function(e){

    const btn = e.target.closest(".option-value");

    if(!btn || btn.disabled) return;


    const card = btn.closest(".collection-product-card");

    if(!card) return;



    // Active button
    const optionBox = btn.closest(".option-values");

    optionBox.querySelectorAll(".option-value").forEach(function(item){
        item.classList.remove("active");
    });

    btn.classList.add("active");

    const json = card.querySelector(".product-variants-json");
    if(!json) return;

    const variants = JSON.parse(json.textContent);

    // Selected options
    function getSelectedOptions(){

        let options = [];

        card.querySelectorAll(".product-option").forEach(function(option){

            let active = option.querySelector(".option-value.active");

            options.push(active ? active.dataset.value : "");

        });

        return options;

    }

    let selectedOptions = getSelectedOptions();
// Find selected variant
    let variant = variants.find(function(v){

        return v.options.every(function(value,index){

            return value == selectedOptions[index];

        });

    });

    if(!variant) return;

    console.log("Variant:",variant);

    /*   UPDATE VARIANT ID  */

    card.querySelectorAll('input[name="id"]').forEach(function(input){

        input.value = variant.id;

    });

    card.querySelectorAll("[data-variant-id]").forEach(function(button){

        button.dataset.variantId = variant.id;

    });

    /*   UPDATE PRICE    */
    const moneyFormat = card
    .closest("product-card-block")
    .getAttribute("money_format");
    const price = card.querySelector(".variant-price");
    if(price){

        price.innerHTML = Shopify.formatMoney(
            variant.price,
            moneyFormat
        );

    }

    /*  ADD TO CART ENABLE / DISABLE  */

    card.querySelectorAll(
        ".buy_now_button,.shop_add_button,.qa_btn"
    ).forEach(function(button){
        button.disabled = !variant.available;

    });

    /*   UPDATE IMAGE  */

      if (variant.featured_media) {

          const mediaId = variant.featured_media.id;

          const swiperEl = card.querySelector(".product-media.swiper");

          if (swiperEl && swiperEl.swiper) {

              const slides = swiperEl.querySelectorAll(".swiper-slide");

              slides.forEach((slide, index) => {

                  if (Number(slide.dataset.mediaId) === Number(mediaId)) {

                      swiperEl.swiper.slideTo(index, 0);

                  }

              });

          }

      }

    /*  CHECK SOLD OUT OPTIONS  */

    card.querySelectorAll(".option-value").forEach(function(optionBtn){

        let testOptions = getSelectedOptions();

        let optionIndex = Array.from(
            card.querySelectorAll(".product-option")
        ).findIndex(function(option){

            return option.contains(optionBtn);

        });

        testOptions[optionIndex] = optionBtn.dataset.value;
        let possibleVariant = variants.find(function(v){
            return v.options.every(function(value,index){
                return value == testOptions[index];
            });

        });

        if(possibleVariant && possibleVariant.available){
            optionBtn.disabled = false;
            optionBtn.classList.remove("soldout");
        }else{
            optionBtn.disabled = true;
            optionBtn.classList.add("soldout");
        }
    });



});

document.querySelectorAll(".product-option .option-values").forEach((slider) => {

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("dragging");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("dragging");
    });

    slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("dragging");
    });

    slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // speed
        slider.scrollLeft = scrollLeft - walk;
    });

});